<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.77786 7.00005C7.49608 7.00005 8.88897 5.60716 8.88897 3.88894C8.88897 2.17072 7.49608 0.777832 5.77786 0.777832C4.05964 0.777832 2.66675 2.17072 2.66675 3.88894C2.66675 5.60716 4.05964 7.00005 5.77786 7.00005Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.5555 1.07715C12.6066 1.57647 13.3333 2.6478 13.3333 3.88887C13.3333 5.12993 12.6066 6.20127 11.5555 6.70059"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 13.2221V12.49C10.6667 11.7135 10.3389 11.0733 9.75547 10.5241C9.17203 9.975 8.3807 9.6665 7.55558 9.6665H4.00003C3.17491 9.6665 2.38359 9.975 1.80014 10.5241C1.21669 11.0733 0.888916 11.7135 0.888916 12.49V13.2221"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.1111 13.2221V12.4901C15.1111 11.7135 14.7834 11.0733 14.1999 10.5241C13.8313 10.1772 13.3796 9.92629 12.8889 9.78857"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
  defineOptions({
    name: 'ClientIcon',
  });
</script>
